module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Text-height-1ce638d473eae3c23a8d884c81582711.svg";